import { render } from "./TrainAIModel.vue?vue&type=template&id=3e37a516&scoped=true"
import script from "./TrainAIModel.vue?vue&type=script&lang=js"
export * from "./TrainAIModel.vue?vue&type=script&lang=js"

import "./TrainAIModel.vue?vue&type=style&index=0&id=3e37a516&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e37a516"],['__file',"modules/train-ai-options/ui/apos/components/TrainAIModel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3e37a516"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3e37a516', __exports__)) {
    api.reload('3e37a516', __exports__)
  }
  
  module.hot.accept("./TrainAIModel.vue?vue&type=template&id=3e37a516&scoped=true", () => {
    api.rerender('3e37a516', render)
  })

}


export default __exports__